// extracted by mini-css-extract-plugin
export default {"TableHeaderContainer":"I_7jmO","tableHeaderContainer":"I_7jmO","TableMobileHeaderContainer":"V7m3PW","tableMobileHeaderContainer":"V7m3PW"};